
import React from 'react'

import './styles/Video.scss';

const Video = (props) => {

    return <div className={props.class || 'fullscreen video-player'}>

        <iframe width="100%" allowFullScreen="allowfullscreen"
          className="youtube-frame"
          src={`https://www.youtube.com/embed/${props.video.code}?autoplay=0&playsinline=1`} />
        <div className="padding fill" >
          <label className="md-caption" >{props.video.name}</label>
          <p className="small description">{props.video.description}</p>
        </div>
          { props.children }

      </div>
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/video/FullScreenVideo.jsx